import { Link } from 'react-router-dom';
import { Shield, FileText, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-slate-950/80 border-t border-primary/10 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Privacy Summary */}
        <div className="bg-slate-900/50 border border-primary/20 rounded-lg p-4 mb-6 max-w-2xl mx-auto">
          <div className="flex items-start gap-3">
            <Shield className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
            <div className="text-sm text-foreground/70">
              <p className="mb-1">
                NUMENAXIS renka tik minimalius duomenis, reikalingus asmeninei analizei ir platformos veikimui.
              </p>
              <p className="mb-1">
                Jūsų informacija nenaudojama rinkodarai ir nėra perduodama tretiesiems asmenims.
              </p>
              <p>
                Mokėjimai (jei taikoma) apdorojami per saugias trečiųjų šalių platformas.
              </p>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-6">
          <Link 
            to="/privatumo-politika" 
            className="flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors"
          >
            <Shield className="w-4 h-4" />
            Privatumo politika
          </Link>
          <Link 
            to="/naudojimosi-salygos" 
            className="flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors"
          >
            <FileText className="w-4 h-4" />
            Naudojimosi sąlygos
          </Link>
          <Link 
            to="/grazinimo-politika" 
            className="flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors"
          >
            <FileText className="w-4 h-4" />
            Grąžinimo politika
          </Link>
          <a 
            href="mailto:info@numenaxis.com" 
            className="flex items-center gap-2 text-sm text-foreground/60 hover:text-primary transition-colors"
          >
            <Mail className="w-4 h-4" />
            info@numenaxis.com
          </a>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground">
            © 2026 NUMENAXIS – savęs pažinimo erdvė. Visos teisės saugomos.
          </p>
        </div>
      </div>
    </footer>
  );
}
